import { render, staticRenderFns } from "./link.vue?vue&type=template&id=45f53e52&scoped=true&"
import script from "./link.vue?vue&type=script&lang=js&"
export * from "./link.vue?vue&type=script&lang=js&"
import style0 from "./link.vue?vue&type=style&index=0&id=45f53e52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f53e52",
  null
  
)

export default component.exports